<template lang="pug">
.reservation-edit-text-modal
  b-modal(v-model="_modalShow" size="lg" @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
    template(#modal-title)
      span {{ modalTitle }}

    .register-body
      FormTextarea(v-model="_text" name="text" key-name="家族からの連絡事項" placeholder="家族からの連絡事項"
        :maxlength="1000" :validation-rules="{ max: 1000 }" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }")

    .testmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="_showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";

/**
 * ### 連絡事項編集モーダル
 */
@Component({
  components: {
    ValidationAlert,
    FormTextarea
  },
  $_veeValidate: { validator: "new" }
})
export default class EditTextModal extends Vue {
  @Prop()
  value!: boolean;
  /** モーダルタイトル */
  @Prop()
  modalTitle!: string;
  /** 連絡事項 */
  @Prop()
  text!: string;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _text(): string {
    return this.text;
  }

  set _text(newValue: string) {
    this.$emit("update:text", newValue);
    return;
  }

  get _showValidationAlert(): boolean {
    return this.showValidationAlert;
  }

  set _showValidationAlert(newValue: boolean) {
    this.showValidationAlert = false;
    return;
  }

  /**
   * ### OKボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public async ok(modalEvent: any): Promise<void> {
    modalEvent.preventDefault();
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.$emit("ok");
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  public cancel(): void {
    this.showValidationAlert = false;
    return;
  }
}
</script>
